import request from "@/utils/request";

// 查询角色列表
export function getRoleList(params) {
  return request({
    url: "/admin/roles",
    method: "get",
    params: params
  });
}

// 查询角色详情
export function getRoleInfo(id) {
  return request({
    url: "/admin/roles/info?id="+id,
    method: "get"
  });
}

// 查询角色菜单列表
export function getRoleMenusList(params) {
  return request({
    url: "/admin/roles/menus",
    method: "get",
    params: params
  });
}

//新增角色
export function addRoles(data) {
  return request({
    url: "/admin/roles",
    method: "post",
    data: data
  });
}

//修改角色
export function updateRoles(data) {
  return request({
    url: "/admin/roles",
    method: "put",
    data: data
  });
}

//删除角色
export function removeRoles(data) {
  return request({
    url: "/admin/roles",
    method: "delete",
    data: data
  });
}

//修改禁用状态
export function updateRolesDisable(data) {
  return request({
    url: "/admin/roles/disable",
    method: "put",
    data: data
  });
}
